import { LEVELS, LEVEL_WORD, levelIndex } from '../../utils/skillSections'

/**
 * The five rungs as dots (Skills UX pass 2026-09-06): filled up to where the
 * person is, a ring on where they want to get. Small on a list row, with the
 * words under it on the page.
 */
interface Props {
  current?: string | null
  target?: string | null
  size?: 'sm' | 'md'
  words?: boolean
  className?: string
}

export function SkillLadder({ current, target, size = 'md', words = false, className = '' }: Props) {
  const ci = levelIndex(current), ti = levelIndex(target)
  const dot = size === 'sm' ? 'h-2 w-2' : 'h-2.5 w-2.5'
  const label = [current ? `now ${LEVEL_WORD[LEVELS[ci!]]}` : 'no level yet', target ? `aiming for ${LEVEL_WORD[LEVELS[ti!]]}` : null].filter(Boolean).join(', ')
  return (
    <span className={`inline-flex flex-col ${className}`} data-testid="skill-ladder">
      <span className="inline-flex items-center gap-1" role="img" aria-label={`Ladder: ${label}`}>
        {LEVELS.map((l, i) => {
          const filled = ci != null && i <= ci
          const isTarget = ti != null && i === ti
          return (
            <span key={l} title={LEVEL_WORD[l]}
                  className={`${dot} rounded-full ${filled ? 'bg-brand' : 'bg-soft'} ${isTarget && !filled ? 'ring-2 ring-brand/60 ring-offset-1 ring-offset-surface' : ''} ${isTarget && filled ? 'ring-2 ring-ok/70 ring-offset-1 ring-offset-surface' : ''}`} />
          )
        })}
      </span>
      {words && (
        <span className="mt-1 flex items-center justify-between gap-2 text-app-micro text-muted">
          <span>{ci != null ? LEVEL_WORD[LEVELS[ci]] : 'Where you are'}</span>
          <span className={ti != null ? 'font-medium text-brand' : ''}>{ti != null ? LEVEL_WORD[LEVELS[ti]] : 'Where you want to get'}</span>
        </span>
      )}
    </span>
  )
}

export default SkillLadder
